import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

// eslint-disable-next-line import/prefer-default-export
export const getNewsfeed = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/newsfeed/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
